import React from 'react'

import { CircularProgress } from '@material-ui/core'

export const AutocompleteLoader = () =>
  <span>
    Загрузка <CircularProgress size={14} style={{marginLeft: 5}}/>
  </span>